<template>
    <section class="step__main">

        <slot name="header"></slot>

        <section class="list__contain" v-show="step">
            <span class="list__title__indicator">Selecione uma unidade</span>

            <!-- UNIDADE -->
            <section
                class="list__item"
                :class="{ active: selectedUnity === unity.unity_id }"
                v-for="(unity, index) in userData.linked_unit" :key="index"
                @click="setSelectedUnity(unity)"
            >
                <v-icon
                size="20"
                :color="selectedUnity == unity.unity_id ? 'success' : '#0000008a'"
                >
                {{
                    selectedUnity === unity.unity_id
                    ? "mdi-checkbox-marked-circle-outline"
                    : "mdi-circle-outline"
                }}
                </v-icon>

                <span>{{ unity.unity.hospital }}</span>
            </section>
        </section>

            <!-- PERFIL -->

        <section class="list__contain" v-show="!step"> 
            <section class="header">
                <span class="list__title__indicator">Selecione um perfil</span>
                <small class="list__title__indicator">
                    {{ profile_unity }}
                </small>
            </section>
            <section
              class="list__item"
           
              v-for="(profile, index) in profile_user_unities" :key="index"
              @click="setSelectedProfile(profile)"
            >
                <v-icon
                size="20"
                :color="selectedProfile === profile ? 'success' : '#0000008a'"
                >
                {{
                    selectedProfile === profile
                    ? "mdi-checkbox-marked-circle-outline"
                    : "mdi-circle-outline"
                }}
                </v-icon>

                <span>{{ profile.profile.name }}</span>
            </section>
        </section>

        <section class="step__actions">
            <v-btn       
                v-if="!step"             
                style="width:15%"
                class="btn__default"
                height="40px"
                depressed
                @click="changeStep"
            >
                <v-icon size="16">mdi-arrow-left</v-icon>
            </v-btn>

            <v-btn
                class="btn__default"
                :style="{ width: step ? '100%' : '75%' }"
                color="success"
                height="40px"
                depressed
                @click="setAction"
            >
                {{ $t('buttons.continue')}}
            </v-btn>
        </section>
    </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

    export default {
        name: "ChooseUnity",

        data: () => ({
            step: 1,
            unity: [],
            selectedUnity: {},
            selectedProfile: {},
            profile_unity:"",
            profile_name: "",
            profile_user_unities: []
        }),

        computed: {
        ...mapGetters({
            userData: "getCurrentUser"
        }),

        // checkStatusButton() {
        //     if (this.step) {
        //         return !this.checkObj(this.selectedUnity);
        //     } else {
        //         return !this.checkObj(this.selectedProfile);
        //     }
        // }
        },

        mounted() {
        }, 

        watch: {
            
        },

        created(){

        },

        methods: {
            ...mapActions(["changeUnityAndProfile"]),

            setSelectedUnity(unity) {

                this.selectedUnity =  unity.unity_id 
                this.profile_user_unities = unity.profile_user_unities
            },

            setSelectedProfile(profile){
                this.selectedProfile = profile;
            },

            checkObj(obj) {
                return Object.keys(obj).length;
            },

            changeStep() {
                this.step == 1 ? this.step-- : this.step++;
                this.profile_unity = this.selectedUnity.linked_unit.name
                this.profile_name = this.selectedUnity.profile_user_unities[0].profile.name
            },

            setAction() {
                const checkUnity = this.checkObj(this.selectedUnity);
                const checkProfile = this.checkObj(this.selectedProfile);

                if (this.step && checkUnity) {
                    this.changeStep();
                } else if (!this.step && checkUnity && checkProfile) {

                    const selectedData = {
                        cpf: this.userData.cpf,
                        password: this.userData.password,
                        unity_id: this.selectedUnity,
                        profile_id: this.selectedProfile.profile_id,
                    }; 
 
                    this.changeUnityAndProfile(selectedData);
                    this.$emit("goToLogin");
                } else {
                    this.$snackbar.setParams(
                    "warning",
                    this.$t("messages.error_not_defined"),
                    this.$t("messages.select_one_option")
                    );
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.step__main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  height: 100%;
  width: 100%;

  .list__title__indicator {
    text-align: center;
  }

  .list__contain {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    padding: 5px;
    text-align: center;
    max-height: 300px;
    overflow-x: auto;
    text-align: left;

    .list__item {
      display: flex;
      align-items: center;
      gap: 6px;
      width: 100%;
      border-radius: 12px;
      padding: 10px;
      background: #fafafa;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
      cursor: pointer;

      span {
        font-size: 13px;
      }
    }

    .active {
      background: #f2fbff;
      box-shadow: rgba(25, 118, 210, 0.2) 0px 0px 0px 1px;
    }

    .header {
      display: flex;
      flex-direction: column;

      small {
        font-size: 12px;
      }
    }
  }

  .step__actions {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    width: 100%;
  }
}
</style>